<!-- 支付界面 -->
<template>
  <div class="divPage">
    <div>
      <div class="divItem">
        <b-row>
          <b-col> 订单状态：<span>等待申请人付款</span> </b-col>
        </b-row>
        <b-row>
          <b-col>
            您的图片已提交，请在24小时内完成支付，超时订单将自动取消
          </b-col>
        </b-row>
      </div>
      <div class="divItem">
        <h6>付款商品</h6>
        <hr />
        <b-row>
          <b-col cols="4">
            <img :src="thumbnailSrc" style="width: 64px" />
          </b-col>
          <b-col cols="5" class="rightText">版面定制服务费</b-col>
          <!-- <b-col cols="3" class="rightText"
            >￥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }}</b-col
          > -->
        </b-row>
        <b-row>
          <b-col cols="4"></b-col>
          <b-col cols="8" class="rightText">
            <van-radio-group v-model="radioPrice" direction="horizontal">
              <van-radio name="1">88元(含充值金0元)</van-radio>
              <van-radio name="2">138元(含充值金50元)</van-radio>
              <van-radio name="3">188元(含充值金100元)</van-radio>
            </van-radio-group>
          </b-col>
        </b-row>
      </div>
      <!-- 邮寄费提示 -->
      <div class="divItem" v-if="youji_tips">
        <b-row>
          <b-col cols="6"></b-col>
          <b-col>
            <font color="red" size="2px">快递费10元（ 实收 0 元 ）</font></b-col
          >
        </b-row>
      </div>

      <!-- 优惠卷 -->
      <!-- <div class="divItem">
        <b-row>
          <b-col>
            <b-form-input
              v-model="voucherCode"
              id="input-voucher-code"
              type="text"
              placeholder="请输入优惠券码"
            ></b-form-input>
          </b-col>
        </b-row>
      </div> -->

      <div class="divItem">
        <h6>结算</h6>
        <hr />
        <!-- <b-row>
          <b-col class="rightText"
            >应付总额：￥{{
              orderInfoObj == null ? "" : orderInfoObj.price / 100
            }}</b-col
          >
        </b-row> -->
        <b-row>
          <b-col class="rightText"
            >应付总额：￥{{ this.amountPaid / 100 }}</b-col
          >
        </b-row>
      </div>

      <div class="divItem">
        <h6>订单信息</h6>
        <hr />
        <b-row>
          <b-col
            >订单编号：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderNo
            }}</span></b-col
          >
        </b-row>
        <b-row>
          <b-col
            >下单时间：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderDateTime
            }}</span></b-col
          >
        </b-row>
      </div>

      <div class="divItemNotice">
        <h6>温馨提示</h6>
        <div>1.支付后，将无法更改以上卡片定制信息</div>
        <div>2.我们将在20个工作日左右为您寄送卡片，请注意查收</div>
        <div>3.卡制作完成后，不退不换</div>

        <div class="divItem">
          <b-row>
            <b-col cols="10" class="mx-auto payBtn">
              <b-button
                block
                variant="danger"
                @click="wxH5Pay()"
                v-preventReClick
                >微信支付</b-button
              >
            </b-col>
            <b-col cols="10" class="mx-auto replaceBtn">
              <b-button block variant="primary" @click="replaceCardface()"
                >更改图片</b-button
              >
            </b-col>
          </b-row>
        </div>

        <!-- loading toast -->
        <div v-show="loading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">下单中</p>
          </div>
        </div>

        <div v-show="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <p class="weui-toast__content">{{ toastMsg }}</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>

    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <b-modal
      ref="model_pay_result"
      title="提示"
      ok-title="已完成支付"
      @ok="doneWxH5Pay()"
      cancel-title="支付遇到问题，重新支付"
      @cancel="reWxH5Pay()"
      no-close-on-esc
      centered
      :hide-header-close="true"
    >
      <p>请确认微信支付是否已完成?</p>
    </b-modal>
    <b-modal
      ref="model_back_ios_app"
      title="提示"
      ok-title="确定"
      @ok="backToIosApp()"
      no-close-on-esc
      ok-only
      centered
      :hide-header-close="true"
    >
      <p>请返回手机银行App,确认支付结果。</p>
    </b-modal>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "OrderPay_app_xy",
  data() {
    return {
      orderInfoObj: null,
      appid: "",
      code: "",
      thumbnailSrc: "",
      loading: false,
      showToast: false,
      toastMsg: "",
      targetUrl: "",
      voucherCode: "",
      errorMsg: "",
      faceValue: "",
      practicalAmt: "",
      originalAmt: "",
      youji_tips: false,
      radioPrice: "", //选择金额
      amountPaid: "", //支付金额
      price_xy: "8800",
      product: "",
    };
  },
  watch: {
    voucherCode: function (newval, oldval) {
      console.log("newval->", newval);
      console.log("oldval->", oldval);
      if (newval == "") {
        this.faceValue = "";
        this.practicalAmt = "";
        this.originalAmt = "";
      }
      console.log("faceValue->", this.faceValue);
    },
    radioPrice: function (newval, oldval) {
      console.log("newval_radio--->", newval);
      console.log("oldval_radio--->", oldval);
      if (newval == "1") {
        this.faceValue = "";
        this.practicalAmt = "8800";
        this.originalAmt = "";
        if (this.product) {
          // 生产环境
          this.amountPaid = "8800";
        } else {
          // 测试环境
          this.amountPaid = "1";
        }
      } else if (newval == "2") {
        this.faceValue = "";
        this.practicalAmt = "13800";
        this.originalAmt = "";
        if (this.product) {
          // 生产环境
          this.amountPaid = "13800";
        } else {
          // 测试环境
          this.amountPaid = "2";
        }
      } else if (newval == "3") {
        this.faceValue = "";
        this.practicalAmt = "18800";
        this.originalAmt = "";
        if (this.product) {
          // 生产环境
          this.amountPaid = "18800";
        } else {
          // 测试环境
          this.amountPaid = "3";
        }
      }
    },
  },
  methods: {
    isProductMode() {
      this.product = config.config_app_xy.isProductMode;
      console.log("product--->", this.product);
      if (this.product) {
        console.log("生产环境");
      } else {
        console.log("测试环境");
      }
    },
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    toOrderResult: function () {
      this.$router.replace({
        name: "OrderResult_app_xy",
        params: {
          orderNo: this.orderInfoObj.orderNo,
        },
      });
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    //H5支付方式初始化获取appid
    initH5PayAction() {
      var that = this;
      var formData = new FormData();
      formData.append("bankCode", "default");
      formData.append("type", "1");
      axios({
        method: "post",
        url: config.config_app_xy.initH5Pay,
        data: formData,
      })
        .then((res) => {
          let result = res.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          that.appid = result.data.appid;
          console.log("appid--->", that.appid);
          that.wxH5PayAction();
        })
        .catch((error) => {
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    wxH5Pay() {
      this.initH5PayAction();
    },
    wxH5PayAction() {
      this.unifyOrder();
    },
    replaceCardface: function () {
      this.$store.commit("xy/reuploadImg");
      var param = {
        isModify: 1,
        orderNo: this.orderInfoObj.orderNo,
        backgroundColor: this.orderInfoObj.backgroundColor,
        isPayed: false,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "SelectCardface_app_xy",
        params: {
          selectParam: selectParam,
        },
      });
    },
    // H5支付
    starToPay(payargs) {
      this.setWxH5payState();
      //{"code":0,"msg":"成功","data":{"timeStamp":"1706582624","h5url":"https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx30104344445466d0fea7a575e018120000&package=4145400295","package":"prepay_id=wx30104344445466d0fea7a575e018120000","appId":"","sign":"","signType":"MD5","nonceStr":""}}
      if (this.isIOS()) {
        let url = window.location.href;
        //ios 襄阳公交APP银行入口支付跳转
        let paySuccessUrl = url;
        let h5url = `${payargs.h5url}&redirect_url=${encodeURIComponent(
          paySuccessUrl
        )}`;
        window.location.href = h5url;
      } else {
        let h5url = payargs.h5url;
        window.location.href = h5url;
      }
    },
    // ios
    isIOS() {
      let equipmentType = "";
      let agent = navigator.userAgent.toLowerCase();
      let iphone = agent.indexOf("iphone");
      let ipad = agent.indexOf("ipad");
      if (iphone != -1 || ipad != -1) {
        equipmentType = "ios";
      }
      return equipmentType == "ios";
    },
    notifyPayResult: function (result) {
      //通知后台，订单支付成功
      //result "SUCCESS" 成功, "FAIL" 失败
      let payResult = {
        orderId: this.orderInfoObj.orderNo,
        ordersStats: result,
      };
      axios
        .post(config.config_app_xy.appNotify, payResult)
        .then(function (response) {
          console.log(response);
          //alert(JSON.stringify(response))
        })
        .catch(function (error) {
          console.log(error);
          //alert(JSON.stringify(error))
        });
    },
    adaptIosUrl: function () {
      var url = window.location.href.split("#")[0];
      if (url.indexOf("?") != -1) {
        this.targetUrl = url.split("?")[0];
      } else {
        this.targetUrl = url;
      }
    },
    wxJsSdk: function () {
      var that = this;
      //var url = window.location.href.split('#')[0];
      this.adaptIosUrl();
      var url = this.targetUrl;
      console.log("wxJsSdkUrl:" + url);
      var formData = new FormData();
      formData.append("shareUrl", url);
      formData.append("bankCode", config.config_app_xy.bankCode);
      formData.append("type", "1");

      axios({
        method: "post",
        url: config.config_app_xy.initWXJSSDKConfigInfo,
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid = data.appid;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          /* {
              signature: "1ba9d96ab3b38bb34037b46d5714d61b659d3031",
              appid: "wxecacb5516c17832b",
              jsapi_ticket: "kgt8ON7yVITDhtdwci0qeR5ZO1LunrcgBtLGj8xD8npFwV-6wRlIWdgjZMmuTynPLmFHHz7E30LFBGwzmBtLOg",
              nonceStr: "6024281b-1600-4960-81b6-87876c9203b4",
              timestamp: "1589963929"
            } */

          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["chooseWXPay"],
          });

          wx.ready(function () {
            that.checkOpenid();
          });
          wx.error(function (res) {
            console.log(res);
          });
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      console.log("url search param:" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return "";
    },
    unifyOrder: function () {
      var that = this;
      var myObj = {
        hbTradeType: 3, //H5支付
        openid: "",
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.amountPaid, //支付金额
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.amountPaid, //订单金额
        appid: this.appid,
      };
      // console.log(JSON.stringify(myObj));
      console.log("myObj--->", myObj);
      that.showLoading();
      axios
        .post(config.config_app_xy.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log("response--->", response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              that.starToPay(payargs);
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    backToIosApp() {
      // 例：徽商银行跳转链接
      // let hsbankApp = "https://pbank.hsbank.cc/app/";
      // 襄阳公交app
      let xybankApp = "https://xycx.xfbus.com.cn";
      window.location.href = xybankApp;
    },
    showIosBackTip() {
      this.$refs["model_back_ios_app"].show();
    },
    showPayResult() {
      this.$refs["model_pay_result"].show();
    },
    setWxH5payState() {
      sessionStorage.setItem("wxh5pay", "paying");
    },
    getWxH5payState() {
      return sessionStorage.getItem("wxh5pay");
    },
    clearWxH5payState() {
      sessionStorage.removeItem("wxh5pay");
    },
    reWxH5Pay() {
      this.clearWxH5payState();
      this.wxH5Pay();
    },
    doneWxH5Pay() {
      this.clearWxH5payState();
      this.toOrderResult();
    },
  },
  destroyed: function () {
    this.clearWxH5payState();
  },
  mounted: function () {
    // 判断是测试环境还是生产环境
    this.isProductMode();
    /* {
         orderNo: '01248790113566597120',
         orderDateTime: '2020-05-22 09:39:22',
         price: 1,
         projectName: 'DIY',
         thumbnailFileUrl: ''
       } */
    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }

    var radio = this.$route.params.radio;
    console.log("radio--->", this.radio);

    let youji_tag = radio;
    if (youji_tag !== undefined) {
      sessionStorage.setItem("youji_tag", youji_tag);
    } else {
      youji_tag = sessionStorage.getItem("youji_tag");
    }
    if (youji_tag === "2") {
      this.youji_tips = true;
    } else {
      this.youji_tips = false;
    }

    console.log(this.orderInfoObj);
    this.thumbnailSrc =
      config.config_app_xy.baseImgUrl + this.orderInfoObj.thumbnailFileUrl;
    console.log("thumbnailSrc:" + this.thumbnailSrc);

    let wxH5state = this.getWxH5payState();
    console.log("wxH5state->", wxH5state);
    if (wxH5state == "paying") {
      //wxh5支付返回后，页面重新加载
      this.showPayResult();
    } else {
      //ios微信h5支付，支付或未支付返回时，跳转回app兼容方案
      // console.log("orderInfoObj is null", this.orderInfoObj == null);
      if (this.isIOS() && this.orderInfoObj == null) {
        this.showIosBackTip();
      }
    }
  },
};
</script>

<style scoped>
.payBtn {
  margin-top: 16px;
}

.replaceBtn {
  margin-top: 16px;
  margin-bottom: 24px;
}

.divItem {
  margin-top: 16px;
  background-color: white;
  padding: 8px;
}

.divItemNotice {
  margin-top: 16px;
  padding: 8px;
}

.rightText {
  text-align: right;
}

.divPage {
  background-color: #f1f2f3;
}
</style>



// WEBPACK FOOTER //
// src/components/xiangyangApp/OrderPay_app_xy.vue